import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58a66c7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__backdrop" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "modal__image" }
const _hoisted_4 = { class: "modal__body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🎉 Você alcançou o limite diário de Decoins! 🎉", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Seu progresso é incrível, "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "continue assim"),
  /*#__PURE__*/_createTextVNode(" e prepare-se para "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "novas conquistas."),
  /*#__PURE__*/_createTextVNode(" Continue nessa trajetória para aprender ainda mais, evoluir suas habilidades e "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "decolar com sucesso!")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "Parabéns, " + _toDisplayString(_ctx.user.name) + "! ", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
        }, "Continuar")
      ])
    ])
  ]))
}